import { Injectable } from '@angular/core';
import { StorageConstants } from 'common/constants/app.constant';
import { API_URL } from 'common/constants/url.constants';
import { ProstartDataModel } from 'common/models/pagemodels/prostart/prostart.model';
import { WelcomeListingModel, WelcomeMetaModel, WelcomeModel } from 'common/models/pagemodels/welcome/welcome.model';
import { BaseDataModel, BaseMetaModel } from 'common/models/utilitymodels/base.model';
import { ComponentData, QueryParams } from 'common/models/utilitymodels/list.model';
import { ListDataWidgetService } from 'common/services/core_services/list.data.widget.service';
import { SystemService } from 'common/services/core_services/system.service';
import { WelcomeService } from 'common/services/data_services/welcome/welcome.service';

@Injectable({
    providedIn: 'root',
})
export class WelcomeWidgetService extends ListDataWidgetService<WelcomeModel, WelcomeListingModel> {
    constructor(public listDataService: WelcomeService, public systemService: SystemService) {
        super(listDataService, systemService);
    }

    createQueryParams(queryParam: QueryParams): any {
        return this.listDataService.createQueryParams(queryParam);
    }
    public getMetaModel(): BaseMetaModel {
        return new WelcomeMetaModel().getMetaModel();
    }

    prepareMetaModel(dataModel: WelcomeModel, metaModel: WelcomeMetaModel, routeData: ComponentData): Promise<WelcomeMetaModel> {
        return new Promise<WelcomeMetaModel>((resolve, reject) => {
            if (this.systemService.isPriLoginTransaction) {
                this.systemService.removeSessionStorage(StorageConstants.isPreLoginInitiat);
                this.systemService.isPriLoginTransaction = false;
                this.systemService.removeSessionStorage(StorageConstants.userData);
            }
            resolve(metaModel);
        });
    }
}
